import { render, staticRenderFns } from "./HomeVi.vue?vue&type=template&id=8779856e&scoped=true&"
import script from "./HomeVi.vue?vue&type=script&lang=js&"
export * from "./HomeVi.vue?vue&type=script&lang=js&"
import style0 from "./HomeVi.vue?vue&type=style&index=0&id=8779856e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8779856e",
  null
  
)

export default component.exports